import React from "react";
import "./css/Schoolsection.css";
import govtImg from "../Component/Images/zpschool.jpg"; 
import privateImg from "../Component/Images/highschool.jpg";
// import govtSir from "../Images/im2.jpg";
// import privateSir from "../Images/im1.png";

export default function SchoolsSection() {
  return (
    <section className="schools-wrapper">

      <h1 className="main-title">ज्ञानाचा सेतू – शासकीय ते खाजगी शिक्षणापर्यंत</h1>
      <p className="sub-title">
       ज्ञान, संस्कार आणि प्रगती यांचे केंद्रस्थळ
      </p>
      <p className="sub-title2">गावाच्या शैक्षणिक प्रगतीचा आधारस्तंभ असलेल्या आमच्या शाळा</p>

      <div className="schools-grid">

    
        <div className="school-card">
          <h2 className="school-heading">शासकीय शाळा</h2>

          <img src={govtImg} alt="Government School" className="school-photo" />

          <div className="info-grid">
            <p>शालेय मुलं : ३२</p>
            <p>शालेय मुली : ३४</p>
            <p>एकूण शिक्षक : ३</p>
            {/* <p>संपर्क : ९८७६५४३२१५</p> */}
          </div>

          <div className="principal-box">
            <div>
              <h4>प्रा. सौ. अनिता रवींद्रकुमार सानप</h4>
              <p>शासकीय शाळा इंचार्ज / मुख्याध्यापक</p>
            </div>
          </div>
        </div>

        {/* ✅ खाजगी शाळा */}
        <div className="school-card">
          <h2 className="school-heading">खाजगी शाळा</h2>

          <img src={privateImg} alt="Private School" className="school-photo" />

          <div className="info-grid">
            <p>शालेय मुलं : २४३</p>
            <p>शालेय मुली : २६५</p>
            <p>एकूण शिक्षक : १६</p>
            {/* <p>संपर्क : ९८७६५४३२१५</p> */}
          </div>

          <div className="principal-box">
            {/* <img src={privateSir} className="principal-img" alt="Principal" /> */}
            <div>
              <h4>प्रा. सौ. वनिता अजय बैता</h4>
              <p>खाजगी शाळा इंचार्ज / मुख्याध्यापक</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
